import * as requestFromServer from "./CoursesCrud";
import { callTypes, courseSlice } from "./CoursesSlice";

const {actions} = courseSlice;

export const getCourses = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getCourses(queryParams)
    .then(response => {
      dispatch(actions.coursesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllCourses = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllCourses(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted(response.data));
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getCourse = (id, parentId) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  if (!id) {
    if (!parentId) {
      return requestFromServer
      .getNewCourse()
      .then(response => {
        dispatch(actions.courseFetched(response.data));
      })
      .catch(error => {
      
      });
    }

    return requestFromServer
    .getNewSubCourse(parentId)
    .then(response => {
      dispatch(actions.courseFetched(response.data));
    })
    .catch(error => {
      
    });
  }

  return requestFromServer
    .getCourse(id)
    .then(response => {
      dispatch(actions.courseFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveCourse = course => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveCourse(course)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteCourses = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteCourses(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanCoursesState = () => dispatch => {
  dispatch(actions.coursesStateCleaned());
}